module.exports = "pegasus_template/assets/themelp1/simple/104.png";